// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import PropertySafetyTwoToneSvg from "@ant-design/icons-svg/es/asn/PropertySafetyTwoTone";
import AntdIcon from '../components/AntdIcon';

var PropertySafetyTwoTone = function PropertySafetyTwoTone(props, ref) {
  return React.createElement(AntdIcon, Object.assign({}, props, {
    ref: ref,
    icon: PropertySafetyTwoToneSvg
  }));
};

PropertySafetyTwoTone.displayName = 'PropertySafetyTwoTone';
export default React.forwardRef(PropertySafetyTwoTone);